import {EmployeeToIssueAssignment} from "../domain/entities/employee-to-issue-assignment.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Emitted when only the timeBudget of an existing (employee, issue) assignment changes,
 * so the same-pairing edit persists as ONE update instead of delete + create.
 * Reactivated by O2D-PRD-104.
 */
export class UpdateEmployeeToIssueAssignmentCommand extends AbstractCommand<EmployeeToIssueAssignment> {

    name = CommandName.UPDATE_EMPLOYEE_TO_ISSUE_ASSIGNMENT;

    tags = ['entity', 'update', 'employee-to-issue-assignment'];

}